/**
 * The session's one API instance.
 *
 * Split out of `AppApiBoundary.tsx` for the same mechanical reason `console-api.ts` was split
 * out of `ClientApiBoundary.tsx`: a `.tsx` that exports anything other than components loses
 * Fast Refresh for the whole module, and this repo lints that as an error rather than a
 * warning. The behaviour is unchanged; only the file boundary moved.
 */
import { createFleetApi } from './create-fleet-api.ts'
import type { TokenSource } from './http-fleet-api.ts'
import type { FleetApi } from './fleet-api.ts'

/**
 * A module-level promise rather than component state.
 *
 * `createFleetApi()` may load a chunk, so a component that built its own would rebuild it on
 * every remount and re-fetch on every navigation. Memoising the PROMISE and not the result
 * means two boundaries mounting in the same tick still share one call. Keyed by nothing,
 * because a session has exactly one base URL: it is read from the environment at build time
 * and cannot change under us.
 */
let pending: Promise<FleetApi> | null = null

export function sessionApi(getToken?: TokenSource, onUnauthorized?: () => void): Promise<FleetApi> {
  pending ??= createFleetApi({ getToken, onUnauthorized })
  return pending
}
